/*
 * lang-dd.js — rozbalovací přepínač jazyků v hlavičce (`details.lang-dd`).
 *
 * ZDROJ: skript „H3“ ze schválených náhledů partnerské stránky
 * (`navrh-pro-agentury-de.html` …). `<details>` funguje bez JS; tohle jen
 * zavře rozbalený seznam klikem mimo a klávesou Escape (fokus zpět na
 * `<summary>`). Vrací počet inicializací (0 nebo 1) jako ostatní moduly.
 */

export function init() {
	if (!document.querySelector('details.lang-dd')) {
		return 0;
	}
	document.addEventListener('click', (e) => {
		document.querySelectorAll('details.lang-dd[open]').forEach((d) => {
			if (!d.contains(e.target)) {
				d.removeAttribute('open');
			}
		});
	});
	document.addEventListener('keydown', (e) => {
		if (e.key !== 'Escape') {
			return;
		}
		const d = document.querySelector('details.lang-dd[open]');
		if (!d) {
			return;
		}
		d.removeAttribute('open');
		const s = d.querySelector('summary');
		if (s) {
			s.focus();
		}
	});
	return 1;
}
